export const debugTranslation = {
  key: 'debugTranslation',
  param: 'debugTranslations=true',
  debugModeKey: 'cimode'
}

export const isDebugTranslations = () => window?.location.search.includes(debugTranslation.param)

export const getDebugTranslationsParam = (isFirstParam: boolean = true): string => {
  if (!isDebugTranslations()) {
    return ''
  }
  return `${isFirstParam ? '?' : '&'}${debugTranslation.param}`
}

export const appendDebugTranslationsParam = (url: string): string => {
  if (!url || !isDebugTranslations() || url.includes(debugTranslation.key)) {
    return url
  }
  const hasQueryParams = url.includes('?')
  return url + getDebugTranslationsParam(!hasQueryParams)
}
